import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { RiHome3Line } from "react-icons/ri";
import { RiSettings3Line } from "react-icons/ri";
import { RiAccountPinCircleLine } from "react-icons/ri";
import { GiExpense } from "react-icons/gi";
import { FaTasks } from "react-icons/fa";

const SideNav = () => {
    let match = useRouteMatch();

    const handleHideNav = () => {
        // hides the side nav on mobile, when a user clicks a link
        if (window.matchMedia("(max-width: 1024px)").matches)
        {
            const burger = document.querySelector('.burger');
            if (burger?.classList.contains("active")) { burger?.click(); }
        }
    }
    
    return (
        <aside className="side">
            <nav className="side-nav">
                <ul className="side-nav-list">
                    <li className="item-container">
                        <Link to={`${match.url}eco/home`} onClick={handleHideNav} className="item btn-type-2">
                            <RiHome3Line />
                            <span className="name">Home</span>
                        </Link>
                    </li>
                    <li className="item-container">
                        <Link to={`${match.url}eco/user-account`} onClick={handleHideNav} className="item btn-type-2">
                            <RiAccountPinCircleLine />
                            <span className="name">
                                Profile
                            </span>
                        </Link>
                    </li>
                    <li className="item-container">
                        <Link to={`${match.url}eco/settings`} onClick={handleHideNav} className="item btn-type-2">
                            <RiSettings3Line />
                            <span className="name">Settings</span>
                        </Link>
                    </li>
                    <li className="item-container">
                        <Link to={`${match.url}eco/tasks`} onClick={handleHideNav} className="item btn-type-2">
                            <FaTasks />
                            <span className="name">Tasks&nbsp;<span className="active-nav-view">List</span></span>
                        </Link>
                    </li>
                    <li className="item-container">
                        <Link to={`${match.url}eco/expenses`} onClick={handleHideNav} className="item btn-type-2">
                            <GiExpense />
                            <span className="name">Expense&nbsp;<span className="active-nav-view">Tracker</span></span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </aside>
    );
};

export default SideNav;
